import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { getFaqs, updateFaqs, createFaqs } from "../../../apis/faqsApi";
import { useParams, useNavigate } from "react-router-dom";
import "./../../../assets/css/popup.css";
import { faqValidationSchema } from "../../../Validations/faqValidation";
import langauge from "../../../lib/common/languages.json";
import { getAppProducts } from "../../../apis/AppProductsApi";

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

export default function AddFaqs() {
  const [loading, setLoading] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [prevDesc, setPrevDesc] = useState(false);
  const [productList, setProductList] = useState([]);

  const navigate = useNavigate();
  const [addFaqsInitial, setAddFaqsInitial] = useState({
    name: "",
    description: "",
    language: "",
    crmProductId: "",
  });
  const { id } = useParams();

  useEffect(() => {
    if (id) {
      setEditLoading(true);
      editFaqs(id);
    }
  }, [id]);
  useEffect(() => {
    fetchProducts();
  }, []);
  const cleanQuillHtml = (html) => {
    if (!html) return "";

    return (
      html
        // Remove empty paragraphs
        .replace(/<p>(\s|&nbsp;|<br\s*\/?>)*<\/p>/gi, "")
        // Remove multiple consecutive <br> tags
        .replace(/(<br\s*\/?>\s*){2,}/gi, "<br/>")
        // Remove empty list items
        .replace(/<li>(\s|&nbsp;|<br\s*\/?>)*<\/li>/gi, "")
        // Remove Quill's default classes
        .replace(/class="[^"]*"/g, "")
        // Remove extra spacing between paragraphs and lists
        .replace(/<\/p>\s*<ul>/gi, "</p><ul>")
        .replace(/<\/p>\s*<ol>/gi, "</p><ol>")
        .replace(/<\/ul>\s*<p>/gi, "</ul><p>")
        .replace(/<\/ol>\s*<p>/gi, "</ol><p>")
        // Clean up whitespace
        .trim()
    );
  };

  const editFaqs = async (id) => {
    setEditLoading(true);
    try {
      const res = await getFaqs(id);
      console.log("res.......faqs", res);
      if (res.result) {
        setAddFaqsInitial({
          name: res.result.name,
          description: res.result.description,
          language: res.result.language,
          crmProductId: res.result.crmProductId,
        });
        setPrevDesc(res.result.description);
        setEditLoading(false);
      }
    } catch (error) {
      console.error("Error fetching faqs:", error);
      console.error("Error fetching faqs:", error);
    } finally {
      setLoading(false);
    }
  };
  const fetchProducts = async () => {
    try {
      console.log("fetching products");
      const res = await getAppProducts();
      console.log(res, "products list");
      console.log(res?.result || [], "products array");

      setProductList(res?.result || []);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };
  useEffect(() => {
    console.log("useEfffect for prevDesc");
    console.log(prevDesc);
  }, [prevDesc]);
  //   console.log("useEfffect for prevDesc");
  //   console.log(prevDesc);
  // }, [prevDesc]);
  const formik = useFormik({
    initialValues: addFaqsInitial,
    enableReinitialize: true,
    validationSchema: faqValidationSchema,
    onSubmit: async (values) => {
      const cleanedValues = {
        ...values,
        description: cleanQuillHtml(values.description),
      };

      try {
        setLoading(true);
        console.log(values);
        let res;
        if (id) {
          res = await updateFaqs(id, values);
        } else {
          res = await createFaqs(values);
          setSuccess(true);
        }
        setLoading(false);
        setMessage(res.result.message);
        formik.resetForm();
      } catch (error) {
        console.error("Error submitting form:", error);
        setLoading(false);
      } finally {
        navigate("/faqs");
      }
    },
  });

  const backClick = () => {
    navigate("/faqs");
  };
  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline", "strike"],
      ["blockquote", "code-block"],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ color: [] }, { background: [] }],
      ["link", "image"],
      ["clean"],
    ],
  };
  return (
    <>
      <div className="main-wrapper">
        <div className="page-wrapper">
          {!editLoading && (
            <div className="content container-fluid">
              <i
                className="fas fa-arrow-left"
                style={{ marginRight: "30px", fontSize: "20px" }}
                onClick={backClick}
              />
              <div className="my-3 p-3 bg-body rounded shadow-sm">
                <h3>{id ? "Edit" : "Add"} Faqs</h3>
                {editLoading ? (
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ height: "50px", padding: "7px 30px" }}
                  >
                    <div className="spinner-border" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : (
                  <form onSubmit={formik.handleSubmit} className="formMaxwidth">
                    <div className="input-block mb-3">
                      <label className="col-form-label">
                        Name <span className="text-danger">*</span>
                      </label>
                      <input
                        className="form-control"
                        type="text"
                        name="name"
                        value={formik.values.name}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.errors.name && formik.touched.name && (
                        <span className="text-danger">
                          {formik.errors.name}
                        </span>
                      )}
                    </div>
                    <div className="input-block mb-3">
                      <label className="col-form-label">
                        Description <span className="text-danger">*</span>
                      </label>

                      <ReactQuill
                        theme="snow"
                        value={formik.values.description || ""}
                        onChange={(content) =>
                          formik.setFieldValue("description", content)
                        }
                        onBlur={() =>
                          formik.setFieldTouched("description", true)
                        }
                        modules={modules}
                      />

                      {formik.errors.description &&
                        formik.touched.description && (
                          <span className="text-danger">
                            {formik.errors.description}
                          </span>
                        )}
                    </div>
                    <div className="input-block mb-3">
                      <label className="col-form-label">
                        Product List <span className="text-danger">*</span>
                      </label>

                      <select
                        className="form-control"
                        name="crmProductId"
                        value={formik.values.crmProductId}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      >
                        <option value="">Select Product</option>

                        {productList.map((product) => (
                          <option key={product.id} value={product.crmProductId}>
                            {product.name}
                          </option>
                        ))}
                      </select>

                      {formik.errors.crmProductId &&
                        formik.touched.crmProductId && (
                          <span className="text-danger">
                            {formik.errors.crmProductId}
                          </span>
                        )}
                    </div>
                    <div className="input-block mb-3">
                      <label className="col-form-label">Language *</label>

                      <select
                        className="form-select"
                        name="language"
                        value={formik.values.language}
                        onChange={formik.handleChange}
                      >
                        <option value="">Select Language</option>

                        {langauge.map((lang) => (
                          <option key={lang.code} value={lang.code}>
                            {lang.label}
                          </option>
                        ))}
                      </select>
                      {formik.errors.language && formik.touched.language && (
                        <span className="text-danger">
                          {formik.errors.language}
                        </span>
                      )}
                    </div>
                    {loading ? (
                      <div
                        className="d-flex justify-content-center align-items-center"
                        style={{ height: "50px", padding: "7px 30px" }}
                      >
                        <div className="spinner-border" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    ) : (
                      <div className="">
                        {loading ? (
                          <div
                            className="d-flex justify-content-center align-items-center"
                            style={{ height: "50px", padding: "7px 30px" }}
                          >
                            <div className="spinner-border" role="status">
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          </div>
                        ) : (
                          <button className="btn btn-primary" type="submit">
                            {id ? "Update" : "Submit"}
                          </button>
                        )}
                      </div>
                    )}
                  </form>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
